import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { initGA, logPageView } from './utils/analytics';

import { ConfigProvider } from 'antd';
import theme from './theme';

// Import layouts
import MainLayout from './layouts/MainLayout';

// Import pages
import HomePage from './pages/HomePage';
import ListFitnessCenterPage from './pages/ListFitnessCenterPage';
import DetailFitnessPage from './pages/DetailFitnessPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ContactPage from './pages/ContactPage';
import InformationCustomerPage from './pages/InformationCustomerPage';
import LoginSuccess from './features/auth/components/LoginModal/LoginSuccess';
import NearbyGymsPage from './pages/HomePage/NearbyGymsPage';
import AboutUs from './pages/aboutUs';
import PackageList from './components/sections/PricingSection/PackageList';
import Success from './components/sections/PricingSection/Success';
import Cancel from './components/sections/PricingSection/Cancel';
import PackageOwnerList from './components/sections/PricingSection/PackageOwnerList';
import CreateGymForm from './components/Gym/CreateGymForm';
import PaymentSuccess from './pages/PaymentGym/PaymentSuccess';
import PaymentCancel from './pages/PaymentGym/PaymentCancel';
import RevenueSummary from './pages/PaymentGym/RevenueSummary';
import CreatePackageForm from './components/Gym/CreatePackageForm';
import GymStatus from './components/Gym/GymStatus';
import PendingGymsList from './components/Gym/PendingGymsList';
import UserPaymentOrders from './components/sections/PricingSection/UserPaymentOrders';


function GAListener({ children }) {
  const location = useLocation();

  useEffect(() => {
    initGA(); // Chỉ cần init 1 lần

    // Mỗi lần route thay đổi thì log lại pageview
    logPageView(location.pathname + location.search);
  }, [location]);

  return children;
}

function App() {
  return (
    <ConfigProvider theme={theme}>
      <Router>
        <GAListener> {
          <Routes>
            <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
            <Route path="/list-fitness-center" element={<MainLayout><ListFitnessCenterPage /></MainLayout>} />
            <Route path="/detail-fitness/:id" element={<MainLayout><DetailFitnessPage /></MainLayout>} />
            <Route path="/register" element={<MainLayout><RegisterPage /></MainLayout>} />
            <Route path="/forgot-password" element={<MainLayout><ForgotPasswordPage /></MainLayout>} />
            <Route path="/contact" element={<MainLayout><ContactPage /></MainLayout>} />
            <Route path="/information-customer" element={<MainLayout><InformationCustomerPage /></MainLayout>} />
            <Route path="/login-success" element={<LoginSuccess />} />
            <Route path="/nearby-gyms" element={<MainLayout><NearbyGymsPage /></MainLayout>} />
            <Route path="/about" element={<MainLayout><AboutUs /></MainLayout>} />
            <Route path="/packages" element={<MainLayout><PackageList /></MainLayout>} />
            <Route path="/success" element={<MainLayout> <Success /></MainLayout>} />
            <Route path="/cancel" element={<MainLayout> <Cancel /></MainLayout>} />
            <Route path="/package-owner-list" element={<MainLayout><PackageOwnerList /></MainLayout>} />
            <Route path="/create-gym" element={<MainLayout><CreateGymForm /></MainLayout>} />
            <Route path="/payment-success" element={<MainLayout><PaymentSuccess /></MainLayout>} />
            <Route path="/payment-cancel" element={<MainLayout><PaymentCancel /></MainLayout>} />
            <Route path="/revenue-summary" element={<MainLayout><RevenueSummary /></MainLayout>} />
            <Route path="/create-package/:gymId" element={<MainLayout><CreatePackageForm /></MainLayout>} />
            <Route path="/gym-status" element={<MainLayout><GymStatus /></MainLayout>} />
            <Route path="/pending-gyms" element={<MainLayout><PendingGymsList /></MainLayout>} />
            <Route path="/user-payment-orders" element={<MainLayout><UserPaymentOrders /></MainLayout>} />
          </Routes>
        }
        </GAListener>
      </Router>
    </ConfigProvider>
  );
}

export default App; 